import React from 'react';
import PropTypes from 'prop-types';
import CustomerDuplicateDialog from 'components/modules/customer/merge/CustomerDuplicateDialog';
import { DUPLICATE_DIALOG_MODE } from 'components/modules/customer/merge/duplicateDialogModes';

/**
 * Backward-compatible merge entry.
 * - showReviewStep=true → MERGE_REVIEW (list then resolve) — banner / Review and Merge
 * - otherwise → MERGE_DIRECT (resolve only) — merge with current
 */
const MergeDialog = ({
    open,
    masterCustomerCode,
    secondaryCustomerCodes,
    onClose,
    onMergeCompleted,
    showReviewStep,
    suggestedCustomer,
    enteredCustomer,
}) => (
    <CustomerDuplicateDialog
        open={open}
        mode={showReviewStep
            ? DUPLICATE_DIALOG_MODE.MERGE_REVIEW
            : DUPLICATE_DIALOG_MODE.MERGE_DIRECT}
        onClose={onClose}
        masterCustomerCode={masterCustomerCode}
        secondaryCustomerCodes={secondaryCustomerCodes}
        suggestedCustomer={suggestedCustomer
            || secondaryCustomerCodes.map((customerCode) => ({ customerCode }))}
        enteredCustomer={enteredCustomer}
        onMergeCompleted={onMergeCompleted}
    />
);

MergeDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    masterCustomerCode: PropTypes.number.isRequired,
    secondaryCustomerCodes: PropTypes.arrayOf(PropTypes.number).isRequired,
    onClose: PropTypes.func.isRequired,
    onMergeCompleted: PropTypes.func,
    showReviewStep: PropTypes.bool,
    suggestedCustomer: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    enteredCustomer: PropTypes.object,
};

MergeDialog.defaultProps = {
    onMergeCompleted: () => {},
    showReviewStep: false,
    suggestedCustomer: null,
    enteredCustomer: {},
};

export default MergeDialog;
